import { render, staticRenderFns } from "./ActiveCodeDetail.vue?vue&type=template&id=4e016037&scoped=true&"
import script from "./ActiveCodeDetail.vue?vue&type=script&lang=js&"
export * from "./ActiveCodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCodeDetail.vue?vue&type=style&index=0&id=4e016037&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e016037",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VContainer,VSimpleTable})
